(() => {
  const init = () => document.querySelectorAll('[data-wyper-catalog]').forEach(catalog => {
    if(catalog.dataset.controlsReady) return;
    catalog.dataset.controlsReady = 'true';
    const buttons = [...catalog.querySelectorAll('[data-catalog-toggle]')];
    const close = () => {
      buttons.forEach(button => button.setAttribute('aria-expanded','false'));
      catalog.querySelectorAll('[data-catalog-panel]').forEach(panel => panel.classList.remove('is-open'));
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      const opening = button.getAttribute('aria-expanded') !== 'true';
      close();
      if(opening) { button.setAttribute('aria-expanded','true'); document.getElementById(button.getAttribute('aria-controls')).classList.add('is-open'); }
    }));
    catalog.addEventListener('keydown', event => { if(event.key === 'Escape') {const active=buttons.find(b=>b.getAttribute('aria-expanded')==='true');close();active?.focus();} });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
